import React from 'react'
import { AccountDeleted } from '../../warden/account-delete'

export const TheNightlyAccountDelete = () => (
    <>
        <AccountDeleted
            title={'Your account has been deleted'}
            paragraph={
                <>
                    Your account with The Nightly has been deleted as requested.
                    If you have any concerns, contact us at
                    [support@thenightly.com.au].
                </>
            }
            backHomeButton={{ show: true, text: 'BACK TO HOME' }}
        />
    </>
)
